import React, { useState, useEffect } from "react";

let setToastFn = null;

export function showToast(message, type = "info", duration = 3000) {
  if (setToastFn) setToastFn({ message, type, duration });
}

export function ToastContainer() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    setToastFn = setToast;
    return () => { setToastFn = null; };
  }, []);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => setToast(null), toast.duration || 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  if (!toast) return null;
  return (
    <div style={{
      position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)",
      background: toast.type === "error" ? "#ffdddd" : "#e0ffe0",
      color: "#333", padding: "12px 24px", borderRadius: 8,
      boxShadow: "0 2px 8px #0002", zIndex: 9999, fontWeight: "bold"
    }}>
      {toast.message}
    </div>
  );
}